<template>
  <div class="main MemberMain">
    <!-- 顶部 -->
    <div class="title">
      <img class="blueCircle" src="../assets/blueCircle.png" />
      <span class="text">会员信息</span>
      <span class="expired" v-if="isExpired">---已到期，请及时缴费</span>
    </div>

    <!-- 表格 -->
    <el-table :data="tableData" border style="width: 99%">
      <el-table-column align="center" prop="memberno" label="会员编号"></el-table-column>
      <el-table-column width="180px" align="center" prop="companyname" label="单位名称">
        <template slot-scope="scope">
          <p @click="handleCompanyname" style="cursor:pointer;">{{scope.row.companyname}}</p>
        </template>
      </el-table-column>
      <el-table-column width="160px" align="center" prop="committeeoption" label="所属专业委员会">
        <template slot-scope="scope">
          <p v-for="(item,index) in scope.row.committeeoption" :key="index" @click="handleCommitteeoption(item.id)" style="cursor:pointer;">{{item.name}}</p>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="_memberlevel" label="会员级别">
        <template slot-scope="scope">
          <p :style="memberlevelColor[scope.row.memberlevel]">{{memberlevelMap[scope.row.memberlevel]}}</p>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="qrcode" label="二维码">
        <img src="../assets/enlargement.png" @click="showQrcode" style="cursor:pointer;" />
      </el-table-column>
      <el-table-column align="center" prop="certificate" label="我的证书">
        <img src="../assets/enlargement.png" @click="showCertificate" style="cursor:pointer;" />
      </el-table-column>
      <el-table-column align="center" prop="contactpersoncontactname" label="联系人"></el-table-column>
      <el-table-column width="120px" align="center" prop="contactpersonphone" label="联系手机"></el-table-column>
      <el-table-column align="center" prop="status" label="状态"></el-table-column>
      <el-table-column width="150px" align="center" prop="enddate" label="会费有效期至"></el-table-column>
      <el-table-column align="center" prop="options">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="handleEdit(scope.row)" v-if="status !== '0'">修改信息</el-button>
          <el-button size="mini" plain @click="handlePrint(scope.row)">打印</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog title="二维码" :visible="qrcodeDialogVisible" width="30%" :before-close="closeQrcodeDialog">
      <img :src="downloadUrl + qrcode" style="width: 100%;">
    </el-dialog>
    <!-- 我的证书 -->
    <el-dialog title="我的证书" :visible="certificateDialogVisible" width="55%" :before-close="closeCertificateDialog">
      <el-button type="primary" @click="downloadCertificate" class="downloadCfBtn">下载</el-button>
      <!-- 我的证书下载部分 -->
      <div ref="certificatePic">
        <img src="../assets/certificate-bg.jpg" style="width: 100%;">
        <div class="certificateText">
          <p>会员编号：{{memberno}}</p>
          <p>会员：{{companyname}}</p>
          <p>会费有效期：{{enddate}}</p>
        </div>
        <div class="certificateDate">
          <p>发证单位：<span>上海市绿色建筑协会</span></p>
          <p>发证日期：<span>{{issuedate}}</span></p>
        </div>
      </div>
    </el-dialog>

    <!-- 中间部分 -->
    <div class="payment-tip" v-if="status === '0'">
      <p>您的入会申请资料已提交审核，协会将尽快进行审核，请导出并打印申请表。如有问题可与协会联系，联系方式：64083368</p>
    </div>
    <div class="middleDiv">
      <img src="../assets/msg.png" />
      <span>
        您是上海市绿色建筑协会会员单位，拥有协会的企业二维码标识（点击
        <img src="../assets/enlargement.png" />可显示二维码大图）,该二维码可用于会议签到，请及时右键进行图片另存，或使用移动设备进行拍照保存。
      </span>
    </div>

    <div>
      <div class="main_news" style="margin: 20px 10px 20px 0;overflow: hidden;">
        <span class="news_title">
          <img src="../assets/news.png" style="margin: 0 10px" />
          <b>重要通知</b>
        </span>
        <span
          style="position:absolute;top:10px;right:10px;cursor: pointer;font-size:14px;color: #333;"
          v-if="noticelist.length > 3"
        >
          <div @click="changeFoldState">{{isFold ? '更多' : '收起'}}</div>
        </span>
        <hr />
        <ul :style="isFold ? 'height: 90px;' : 'max-height: 155px;overflow-y: scroll;'">
          <li v-for="(item,index) in noticelist" :key="index" style="height: 30px;line-height:20px;margin: 0 10px;font-size: 14px;"><a :href="item.url" style="text-decoration: none;color:#999;" target="_blank">{{item.title}}</a></li>
        </ul>
      </div>
      <div class="main_news" style="margin: 20px 0 20px 0;overflow: hidden;">
        <span class="news_title">
          <img src="../assets/news.png" style="margin: 0 10px" />
          <b>协会动态</b>
        </span>
        <span
          style="position:absolute;top:10px;right:10px;cursor: pointer;font-size:14px;color: #333;"
          v-if="dynamicList.length > 3"
        >
          <div @click="changeFoldState">{{isFold ? '更多' : '收起'}}</div>
        </span>
        <hr />
        <ul :style="isFold ? 'height: 90px;' : 'max-height: 155px;overflow-y: scroll;'">
          <li v-for="(item,index) in dynamicList" :key="index" style="height: 30px;line-height:20px;margin: 0 10px;font-size: 14px;"><a :href="item.url" style="text-decoration: none;color:#999;" target="_blank">{{item.title}}</a></li>
        </ul>
      </div>
    </div>
    <!-- 下部分 -->
    <div class="title" style="clear: both">
      <img class="blueCircle" src="../assets/blueCircle.png" />
      <span class="text">其他系统</span>
    </div>
    <div>
      <!-- <a href="http://192.168.80.216:9880/green/contributionAward/login.html" target="_blank">
        <img class="img_othersystem" src="../assets/contribution_project.png" />
      </a>
      <a href="http://192.168.80.216:9880/green/contributionAward/personLogin.html" target="_blank">
        <img class="img_othersystem" src="../assets/contribution_individual.png" />
      </a> -->
      <a
        href="http://117.74.136.106:18805/#/"
        target="_blank"
      >
        <img class="img_othersystem" src="../assets/green_building.png" />
      </a>
    </div>

     <!-- 编辑消息弹窗 -->
     <el-dialog title="提醒" :visible.sync="showNoticeMsg" width="30%" center>
        <el-row type="flex" justify="center" align="middle" style="margin-top: 10px;">
          <p>{{noticeTitle}}</p>
        </el-row>
        <el-row type="flex" justify="center" align="middle" style="margin-top: 20px;">
          <p>{{noticeContent}}</p>
        </el-row>
        <el-row type="flex" justify="center" align="middle" style="margin-top: 20px;" v-if="noticeFileName">
          <el-button round size="mini" type="success" @click="downloadFile()">附件下载</el-button>
        </el-row>
      <div slot="footer" class="dialog-footer" style="display:flex;justify-content:center;margin-top: 20px;">
        <el-button @click="showNoticeMsg=false">知道了</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as Cache from '../utils/cache'
import * as API from '../utils/apiService'
import html2canvas from 'html2canvas'
import config from '../config'

const { downloadUrl } = config

export default {
  data () {
    return {
      downloadUrl: downloadUrl,
      isExpired: false, // 是否到期
      tableData: [],
      memberno: '', // 会员编号
      companyname: '', // 单位名称
      committeeoption: [], // 所属专业委员会
      _memberlevel: '', // 会员级别
      qrcode: '', // 二维码
      certificate: '', // 证书（编号、会员单位、有效期）
      contactpersoncontactname: '', // 联系人
      contactpersonphone: '', // 联系人手机
      status: '', // 状态
      enddate: '', // 有效期
      issuedate: '', // 发证日期
      qrcodeDialogVisible: false, // 是否弹出二维码dialog
      certificateDialogVisible: false, // 是否弹出我的证书dialog
      id: '',
      noticelist: [], // 重要通知列表
      dynamicList: [], // 协会动态列表
      isFold: true, // 是否折叠 
      isChangeClass: true, // 是否要滚动的样式
      showNoticeMsg: false,
      noticeTitle: '',
      noticeContent: '',
      noticeFileName: '',
      memberlevelMap: {
        0: '会员',
        1: '理事',
        2: '常务理事',
        3: '副会长'
      },
      memberlevelColor: {
        0: 'color:#FFaa00',
        1: 'color:green',
        2: 'color:blue',
        3: 'color:red'
      },
      statusMap: {
        0: '未处理',
        1: '已处理',
        3: '暂存'
      },
      committeeoptionMap: {
        '-24806': '规划与建筑设计专业委员会',
        '-24807': '绿色建造专业委员会',
        '-24808': '绿色住宅专业委员会',
        '-24809': '绿色建筑运行管理专业委员会',
        '-24810': '绿色建材专业委员会',
        '-24811': '绿色建筑设备设施专业委员会',
        '-24812': '节水与水资源利用专业委员会',
        '-24813': '建筑绿化专业委员会',
        '-24814': '绿色交通设施专业委员会',
        '-24815': '绿色能源和再生资源专业委员会',
        '-24818': '绿色照明专业委员会',
        '-24819': '地下空间绿色低碳专业委员会',
        '-24816': 'BIM',
        '-24817': '其他'
      }
    }
  },
  mounted () {
    this.asyncFindOneInfo()
    this.getNoticeList()
    this.getDynamicList()
    this.asyncGetNoticeMsg()
  },
  methods: {
    asyncFindOneInfo () {
      let params = {
        userid: Cache.getUserInfo().id
      }
      API.findOneInfo(params).then(resp => {
        if (resp.resultCode === '0000') {
          this.status = resp.data.status
          if (resp.data.memberno) {
            if (!resp.data.enddate) {
              this.enddate = '已到期，请及时缴费'
            } else {
              if (new Date(resp.data.enddate).getTime() - new Date().getTime() < 0) {
                this.enddate = '已到期，请及时缴费'
              } else {
                this.enddate = resp.data.enddate
              }
            }
          }
          this.tableData = [
            {
              ...resp.data,
              _memberlevel: this.memberlevelMap[resp.data.memberlevel], // 会员级别覆盖
              status: this.statusMap[resp.data.status], // 状态覆盖
              enddate: this.enddate,
              committeeoption: resp.data.committeeoption.split(',').map(id => ({
                name: this.committeeoptionMap[id],
                id
              })) // 专委会覆盖
            }
          ]
          this.qrcode = resp.data.qrcode
          this.memberno = resp.data.memberno
          this.companyname = resp.data.companyname
          this.enddate = resp.data.enddate
          this.issuedate = resp.data.issuedate
          this.id = resp.data.committeeoption.replace(',', '')
          // 发正日期数字转中文
          var yearPlace = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九']
          var monthPlace = ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十', '十一', '十二']
          if (resp.data.issuedate) {
            var strs = resp.data.issuedate.split('-')
            var year = strs[0]
            var month = strs[1]
            this.issuedate = yearPlace[year.charAt(0)] + yearPlace[year.charAt(1)] + yearPlace[year.charAt(2)] + yearPlace[year.charAt(3)] + '年'
            this.issuedate += monthPlace[parseInt(month) - 1] + '月'
          }
        }
      })
    },
    // 查询弹窗信息
    asyncGetNoticeMsg () {
      let params = {
        userid: Cache.getUserInfo().id
      }
      API.getNoticeMsg(params).then(resp => {
        if (resp.resultCode === '0000') {
          this.status = resp.data.status
          if (resp.data) {
            this.showNoticeMsg = true
            this.noticeTitle = resp.data.title
            this.noticeContent = resp.data.content
            this.noticeFileName = resp.data.filename
          }
        }
      })
    },
    showQrcode () {
      this.qrcodeDialogVisible = true
    },
    showCertificate () {
      this.certificateDialogVisible = true
    },
    // 点关闭触发的事件
    closeQrcodeDialog () {
      this.qrcodeDialogVisible = false
    },
    closeCertificateDialog () {
      this.certificateDialogVisible = false
    },
    // 下载证书
    fileDownload (downloadURL) {
      var aLink = document.createElement('a')
      aLink.style.display = 'none'
      aLink.href = downloadURL
      aLink.download = '我的证书.png'
      // 触发点击-然后移除
      document.body.appendChild(aLink)
      aLink.click()
      document.body.removeChild(aLink)
    },
    // 将html元素转换成canvas
    downloadCertificate () {
      html2canvas(this.$refs.certificatePic).then(canvas => this.fileDownload(canvas.toDataURL()))
    },
    // 点击公司名称
    handleCompanyname () {
      this.$router.push('/previewApplication')
    },
    // 点击专委会
    handleCommitteeoption (id) {
      if (id !== '-24816' || id !== '24817') {
        let params = {
          id
        }
        API.findByCommitteeid(params).then(resp => {
          window.open(resp.data.link)
        })
      }
    },
    // 修改信息
    handleEdit (item) {
      this.$router.push('/editApplication')
    },
    // 打印
    handlePrint (item) {
      let params = {
        userid: Cache.getUserInfo().id
      }
      API.downloadWord(params).then(resp => {
        if (resp.resultCode === '0000') {
          window.open(downloadUrl + resp.resultMsg)
        }
      })
    },
    // 查询新闻列表
    getNoticeList () {
      let params = {
        category: 'tz'
      }
      API.getNewsList(params).then(resp => {
        if (resp.resultCode === '0000') {
          this.noticelist = resp.data
        }
      })
    },
    // 查询协会动态列表
    getDynamicList () {
      let params = {
        category: 'dt'
      }
      API.getNewsList(params).then(resp => {
        if (resp.resultCode === '0000') {
          this.dynamicList = resp.data
        }
      })
    },
    changeFoldState () {
      this.isFold = !this.isFold
    },
    downloadFile () {
      window.open(this.downloadUrl + this.noticeFileName)
    }
  }
}
</script>

<style lang="scss">
.MemberMain {
  .downloadCfBtn {
    position: absolute;
    right: 100px;
    top: 8px;
  }
  .certificateText {
    width: 300px;
    position: absolute;
    right: 70px;
    top: 180px;
    p {
      font-size: 22px;
      color: #000000;
      line-height: 36px;
    }
  }
  .certificateDate {
    position: absolute;
    right: 80px;
    bottom: 120px;
    p {
      font-size: 14px;
      color: #000000;
      line-height: 28px;
    }
    span {
      font-size: 16px;
    }
  }
  .el-dialog__body {
    padding: 0!important;
  }
  .blueCircle {
    vertical-align: middle;
    width: 30px;
    height: 30px;
  }
  .text {
    margin-left: 0;
    color: #3778ff;
  }
  .expired {
    color: #f00;
  }
  .middleDiv {
    width: 99%;
    background: #e2e6ee;
    margin-top: 15px;
    vertical-align: center;
    height: 30px;
    line-height: 30px;
    white-space: nowrap;
    span {
      color: #666;
      font-size: 12px;
    }
    img {
      vertical-align: middle;
      margin: 0 3px;
    }
  }
  .main_news {
    float: left;
    width: 49%;
    background: rgba(255, 255, 255, 1);
    border-radius: 3px;
    padding-top: 10px;
    position: relative;
    max-height: 200px;
    min-height: 106px;
    .moreClass {
      overflow-y: scroll;
    }
    .foldClass {
      overflow-y: hidden;
    }
  }
  .news_title {
    height: 23px;
    line-height: 20px;
    color: #5d5d5d;
  }
  .news_text {
    vertical-align: middle;
    font-size: 86px;
    color: #e99b9b;
    font-family: PingFang-SC-Medium;
    font-weight: 500;
  }
  .el-button--mini {
    padding: 5px;
  }
  .el-button + .el-button {
    margin-top: 5px;
    margin-left: 0;
  }
  hr {
    height: 1px;
    margin: 10px 0;
    border: 0;
    background-color: #e6e6e6;
  }
  .payment-tip {
    margin-top: 15px;
    p {
      font-size: 16px;
      line-height: 24px;
      color: red;
    }
  }
}
</style>
